"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxSkeletonTile = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var ProductBoxSkeletonTile = function ProductBoxSkeletonTile(_ref) {
  var skeletonRef = _ref.skeletonRef;
  var rootClassName = (0, _classnames["default"])('cds-ProductBox', 'cds-Skeleton-Wrapper--Pulse');
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-ProductBoxWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName,
    ref: skeletonRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ProductBox-ImageLink cds-Skeleton--ImageFull"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ProductBox-Title cds-Skeleton--TextFull"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ProductBox-WrapperFeatures"
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "cds-Table cds-Table--FeaturesSmall"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextShort"
  }))));
};
exports.ProductBoxSkeletonTile = ProductBoxSkeletonTile;